(function () {
  const autofitText = () => {
    const vminSize =
      (67 * Math.min(window.innerWidth, window.innerHeight)) / 100;
    const maxFontSize = Math.min(vminSize, 550);
    document.querySelectorAll(".hero-text").forEach((el) => {
      // Measure the text as it currently renders and scale from there. Width is
      // linear in font size, so currentWidth / currentFontSize is the width per
      // px of type, whatever size the text happens to be at right now. Reading
      // both from the same layout keeps them consistent, so this lands on the
      // right size in one pass without writing a value first and measuring the
      // result -- a round trip that reads stale layout and oscillates.
      const computedStyle = getComputedStyle(el);
      const availableWidth = parseFloat(computedStyle.width);
      const currentFontSize = parseFloat(computedStyle.fontSize);
      const range = document.createRange();
      range.selectNodeContents(el);
      const currentWidth = range.getBoundingClientRect().width;
      if (currentWidth > 0 && availableWidth > 0 && currentFontSize > 0) {
        const fittedFontSize =
          (currentFontSize * availableWidth) / currentWidth;
        el.style.setProperty(
          "--autoFontSize",
          Math.min(fittedFontSize, maxFontSize)
        );
      }
      autofitContainers.add(el.parentElement);
    });
  };
  const [onloadOld, onresizeOld, autofitContainers] = [
    window.onload,
    window.onresize,
    new Set(),
  ];
  window.onresize = () => {
    if (onresizeOld) onresizeOld();
    autofitText();
  };
  window.onload = () => {
    if (onloadOld) onloadOld();
    autofitText();
    autofitContainers.forEach((c) =>
      new MutationObserver((ms) => {
        autofitText();
      }).observe(c, {
        attributes: true,
        attributeFilter: ["style"],
      })
    );
  };
  autofitText();
  document.addEventListener("shopify:section:load", function () {
    autofitText();
  });
})();
